<template>
  <template v-if="record.display != 0">
    <template v-if="record.setting?.fieldType == 1">
      <div class="comp-xl-follow-field">{{ record.fieldValue }}</div>
    </template>
    <template v-else-if="record.setting?.fieldType == 2 || record.setting?.fieldType == 3 || record.setting?.fieldType == 4 || record.setting?.fieldType == 5">
      <ly-tag-fields :fieldValue="record?.fieldValue" :record="recordArray" :fieldKey="record.setting?.fieldKey" :styleInfo="record.setting?.fieldExt" :fieldType="record?.setting?.fieldType" />
    </template>
    <template v-else-if="record.setting?.fieldType == 6">
      <template v-if="record.fieldValue?.length > 0">
        <xl-avatar v-for="(itemAvatar, index) in record.fieldValue" :key="index" :avatar="{ name: itemAvatar?.userName || '', url: itemAvatar?.avatar, id: itemAvatar?.userId }" :size="22" />
      </template>
      <template v-else>-</template>
    </template>
    <template v-else-if="record.setting?.fieldType == 7">
      <template v-if="parseFloat(record.fieldValue) >= 0">
        <span>{{ tools.getNumberShow(record.fieldValue, record.setting?.fieldExt) }}{{ JSON.parse(record.setting?.fieldExt)?.numberUnit ? JSON.parse(record.setting?.fieldExt)?.numberUnit : '' }}</span>
      </template>
      <template v-else>-</template>
    </template>
    <template v-else-if="record.setting?.fieldType == 8">
      <template v-if="record.fieldValue">
        <span v-if="record?.setting?.fieldExt">{{ dayjs(record.fieldValue).format(record?.setting?.fieldExt) }}</span>
        <span v-else-if="record.fieldValue?.split(' ')?.length === 2">{{ dayjs(record.fieldValue).format('YYYY-MM-DD HH:mm:ss') }}</span>
        <span v-else>{{ dayjs(record.fieldValue).format('YYYY-MM-DD') }}</span>
      </template>
      <template v-else>-</template>
    </template>
    <template v-else-if="record.setting?.fieldType == 9">
      <template v-if="record?.fieldValue">
        <span>{{ Object.values(JSON.parse(record.fieldValue))?.join('/') }}</span>
      </template>
      <template v-else>-</template>
    </template>
    <template v-else-if="record.setting?.fieldType == 11">
      <jw-link v-if="record?.fieldValue" :href="record?.fieldValue" target="_blank">{{ $t('查看') }}</jw-link>
      <template v-else>-</template>
    </template>
    <template v-else-if="record.setting?.fieldType == 12">
      <ly-association v-if="record?.fieldValue?.value && record?.fieldValue?.label" mask :fieldName="record?.fieldValue?.value" :value="record?.fieldValue" :entity="record.setting.fieldExt"></ly-association>
      <template v-else>-</template>
    </template>
    <template v-else-if="record.setting?.fieldType == 16">
      {{ tools.getPriceShow(record?.fieldValue, record?.setting?.fieldExt) || '-' }}
    </template>
    <template v-else-if="record.setting?.fieldType == 18">
      <template v-if="getAttach?.length">
        <!-- <ly-attachment-list :fieldValue="record?.fieldValue" :all="true" /> -->
        <div class="attachments-preview-list">
          <span class="attach-item" v-for="(item, index) of getAttach" :key="item?.url" @click.stop>
            <fh-attachment-preview :file-item="item" :show-video-cover="true" :icon-style="iconStyle60" :showName="true" :index="index" :list="getAttach" />
          </span>
        </div>
      </template>
      <template v-else>-</template>
    </template>
    <template v-else-if="record.setting?.fieldType == 21">
      <template v-if="record?.setting?.business?.fieldType === 6">
        <template v-if="record?.fieldValue && record.fieldValue?.length">
          <template v-for="itemUser in record.fieldValue" :key="itemUser?.userId">
            <xl-avatar :avatar="{ name: itemUser?.userName || '', url: itemUser?.avatar, id: itemUser?.userId }" :size="22" />
          </template>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="record?.setting?.business?.fieldType === 7">
        <template v-if="parseFloat(record.fieldValue) >= 0">
          <span>{{ tools.getNumberShow(record.fieldValue, record.setting?.business?.fieldExt) }}{{ JSON.parse(record.setting?.business?.fieldExt)?.numberUnit ? JSON.parse(record.setting?.business?.fieldExt)?.numberUnit : '' }}</span>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="record?.setting?.business?.fieldType === 9">
        <template v-if="record.fieldValue">
          <span>{{ Object.values(JSON.parse(record.fieldValue))?.join('/') }}</span>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="record?.setting?.business?.fieldType === 11">
        <jw-link v-if="record.fieldValue" :href="record.fieldValue" target="_blank">{{ $t('查看') }}</jw-link>
        <template v-else>-</template>
      </template>
      <template v-else-if="record?.setting?.business?.fieldType === 12">
        <template v-if="record?.fieldValue?.label && record?.fieldValue?.value">
          <ly-association :fieldName="record.fieldValue.label" :value="record.fieldValue" :entity="record.fieldValue.business"></ly-association>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="record?.setting?.business?.fieldType === 16">
        {{ tools.getPriceShow(record.fieldValue, record.setting?.business?.fieldExt) || '-' }}
      </template>
      <template v-else-if="record?.setting?.business?.fieldType === 18">
        <template v-if="record?.fieldValue">
          <ly-attachment-list :fieldValue="record?.fieldValue" :all="true" />
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="record?.setting?.business?.fieldType === 22">
        <template v-if="record?.fieldValue && record?.fieldValue?.length">
          <span>{{
            record?.fieldValue
              ?.map((i) => {
                return i.name;
              })
              .join(',')
          }}</span>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="record?.setting?.business?.fieldType === 23">
        <template v-if="record?.fieldValue">
          {{ tools.getPercentage(record?.fieldValue, record?.setting?.business?.fieldExt) + '%' || '-' }}
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="record?.setting?.business?.fieldType === 24">
        <template v-if="record?.setting?.business?.fieldExt && typeof JSON.parse(record?.setting?.business?.fieldExt) == 'object'">
          <!-- 金额 汇总金额 -->
          <template v-if="JSON.parse(record?.setting?.business?.fieldExt)?.type == 6 || JSON.parse(record?.setting?.business?.fieldExt)?.type == 16">
            {{ record?.fieldValue ? tools.getPriceShow(record?.fieldValue, record?.setting?.business?.fieldExt) : '-' }}
          </template>
          <!-- 数字 汇总数字 -->
          <template v-else-if="JSON.parse(record?.setting?.business?.fieldExt)?.type == 5 || JSON.parse(record?.setting?.business?.fieldExt)?.type == 7">
            {{ record?.fieldValue ? tools.getNumberShow(record?.fieldValue, record?.setting?.business?.fieldExt) : '-' }}
          </template>
          <!-- 百分比 -->
          <template v-else-if="JSON.parse(record?.setting?.business?.fieldExt)?.type == 23">
            {{ record?.fieldValue ? tools.getPercentage(record?.fieldValue, record?.setting?.business?.fieldExt) + '%' : '-' }}
          </template>
          <template v-else>{{ record?.fieldValue || '-' }}</template>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="record.setting?.business?.fieldType === 25">
        <template v-if="record?.fieldValue && Array.isArray(record?.fieldValue) && record?.fieldValue?.length">
          <template v-for="(ff, i) in record?.fieldValue" :key="i">
            <ly-association mask :fieldName="record?.value" :value="ff" :entity="record.setting.fieldExt"></ly-association>
          </template>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="record.setting?.business?.fieldType === 26">
        <template v-if="record?.fieldValue">
          <ly-rich-text :fieldValue="record?.fieldValue" :isMaxHeight="true" :isSingleLine="false"></ly-rich-text>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else>
        {{ record?.fieldValue || '-' }}
      </template>
    </template>
    <template v-else-if="record.setting?.fieldType == 22">
      <template v-if="record?.fieldValue && record?.fieldValue?.length > 0">
        <span>{{
          record?.fieldValue
            ?.map((i) => {
              return i.name;
            })
            .join(',')
        }}</span>
      </template>
      <template v-else>-</template>
    </template>
    <template v-else-if="record.setting?.fieldType == 23">
      <template v-if="record?.fieldValue">
        {{ tools.getPercentage(record?.fieldValue, record?.setting?.fieldExt) + '%' || '-' }}
      </template>
      <template v-else>-</template>
    </template>
    <template v-else-if="record.setting?.fieldType == 24">
      <template v-if="record?.setting?.fieldExt && typeof JSON.parse(record?.setting?.fieldExt) == 'object'">
        <!-- 汇总金额，金额 -->
        <span v-if="JSON.parse(record?.setting?.fieldExt).type == 6 || JSON.parse(record?.setting?.fieldExt).type == 16">
          {{ record?.fieldValue ? tools.getPriceShow(record?.fieldValue, JSON.parse(record?.setting?.fieldExt)?.dataType) : '-' }}
        </span>
        <!-- 百分比 -->
        <template v-else-if="JSON.parse(record?.setting?.fieldExt)?.type === 23">
          {{ record?.fieldValue ? tools.getPercentage(record?.fieldValue).toFixed(JSON.parse(record?.setting?.fieldExt)?.dataType) + '%' : '-' }}
        </template>
        <!-- 其他类型 -->
        <span v-else>
          {{ record?.fieldValue.toString() || '-' }}
        </span>
      </template>
      <template v-else>{{ record?.fieldValue || '-' }}</template>
    </template>
    <template v-else-if="record.setting?.fieldType == 25">
      <template v-if="record?.fieldValue && Array.isArray(record?.fieldValue) && record?.fieldValue?.length">
        <template v-for="(ff, i) in record?.fieldValue" :key="i">
          <ly-association mask :fieldName="record?.value" :value="ff" :entity="record.setting.fieldExt"></ly-association>
        </template>
      </template>
      <template v-else>-</template>
    </template>
    <!-- 富文本 -->
    <template v-else-if="record.setting?.fieldType === 26">
      <template v-if="record?.fieldValue">
        <ly-rich-text :fieldValue="record?.fieldValue" :isMaxHeight="true" :isSingleLine="false"></ly-rich-text>
      </template>
      <template v-else>-</template>
    </template>
    <template v-else>
      <div class="comp-xl-follow-field">{{ record.fieldValue }}</div>
    </template>
  </template>
</template>

<script setup>
import { tools } from '@/utils/tools.js';
import dayjs from 'dayjs';
import { computed } from 'vue';
const props = defineProps({
  record: {
    //字段列表
    type: Object,
    default: () => {}
  },
  recordArray: {
    //字段列表
    type: Array,
    default: () => []
  }
});
const iconStyle60 = {
  width: '60px',
  height: '60px'
};
const record = computed(() => props.record);
const recordArray = computed(() => props.recordArray);
const getAttach = computed(() => {
  const fieldValue = props.record?.fieldValue;

  if (tools.isJSON(fieldValue)) {
    return JSON.parse(fieldValue);
  }

  if (Array.isArray(fieldValue) && fieldValue.length > 0) {
    return fieldValue;
  }

  return [];
});
</script>
<style scoped lang="less">
@import './xl-follow-field.less';
</style>
